import { render } from "./MSReflectionAddModal.vue?vue&type=template&id=5ec8d771&scoped=true&ts=true"
import script from "./MSReflectionAddModal.vue?vue&type=script&lang=ts"
export * from "./MSReflectionAddModal.vue?vue&type=script&lang=ts"

import "./MSReflectionAddModal.vue?vue&type=style&index=0&id=5ec8d771&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec8d771"]])

export default __exports__